module.exports = __webpack_public_path__ + "img/delete-app.44447f22.svg";